import { FetchError } from '@/connection/helpers';
import { GetThemePacks } from '@/connection/theme-packs';
import { RootState } from '@/store/main';
import { ThemePack } from '@/types/theme-packs.types';
import { TemplatesReducerCreator } from '../types';

const fetchThemePacksReducer = (create: TemplatesReducerCreator) => {
  return create.asyncThunk(
    async (
      { channel, returnStoreStateIfExists = true }: { channel: number; returnStoreStateIfExists?: boolean },
      { getState, rejectWithValue }
    ) => {
      if (returnStoreStateIfExists) {
        // return from state if exists
        const state = getState() as RootState;
        const themePacks = state?.templates?.themePacks as ThemePack[] | null;
        if (themePacks) {
          return themePacks;
        }
      }
      try {
        return GetThemePacks(channel);
      } catch (error) {
        console.error(error);
        if (error instanceof FetchError) {
          return rejectWithValue(error.message);
        }

        throw error;
      }
    },
    {
      fulfilled: (state, action) => {
        state.themePacks = action.payload;
      },
      pending: (state) => {
        state.loadingThemePacks = true;
      },
      rejected: (_, action) => {
        console.error(action.error);
        // TODO
        // add an error to state and show alert in the UI component
      },
      settled: (state) => {
        state.loadingThemePacks = false;
      },
    }
  );
};

export default fetchThemePacksReducer;
